import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=7b3d027a&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=7b3d027a&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=7b3d027a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3d027a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b3d027a')) {
      api.createRecord('7b3d027a', component.options)
    } else {
      api.reload('7b3d027a', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=7b3d027a&scoped=true", function () {
      api.rerender('7b3d027a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/paycools/AppMain.vue"
export default component.exports